import React, { useState, memo } from 'react';
import ProgressPopup from './okr/modals/kr-progress';
/**
* Donut circle component.
*/
const BarChartComp = (props) => {
  const [showProgressPopup, setShowProgressPopup] = useState(false);

  const getCount = () => {
    const { count } = props;
    return count > 100 ? 100 : count;
  }

  const getLabelText = () => {
    return getCount();
  }

  const getStrokeDashOffset = () => {
    return (((100 - getCount()) / 100) * (Math.PI * 2 * props.radius));
  }

  const getCircleCircumference = () => {
    return (2 * Math.PI * props.radius).toFixed(2);
  }

  const toggleKrProgressPopup = (val) => {
    setTimeout(()=>{
      setShowProgressPopup(val);
    },800)							
  }
  var count = getCount();
  var count = count < 0 ? '--' : count+ '%';
  var type = typeof props.type !== 'undefined' ? true : false; 
  const { color, radius, width, height } = props;
  const xDivide = Math.round(width / 2);

  const wrapperStyle = { color };
  const strokeStyle = {
    strokeWidth: 4,
    strokeDashoffset: `${getStrokeDashOffset()}px`,
    strokeDasharray: getCircleCircumference(),
    stroke: color,
  };
  const circleStyle = {
    strokeWidth: props.stroke ? props.stroke: 5,
    strokeDashoffset: 0,
    strokeDasharray: getCircleCircumference(),
    stroke: '#BBBBBB',
  };

  return (
    <div className="goal-donut-circle goal-donut-circle-empty-content barchartcomp-wrapper" data-pct={count} style={wrapperStyle} 
    onMouseOver={() => toggleKrProgressPopup(true)} onMouseLeave={() => toggleKrProgressPopup(false)}>
      {
        showProgressPopup && type
          &&
        <ProgressPopup />
      }
      <svg width={width} aria-hidden="true" height={height} version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle r={radius} cx={xDivide} cy={xDivide} fill="transparent" style={circleStyle} />
        <circle r={radius} cx={xDivide} cy={xDivide} fill="transparent" transform={`rotate(270,${xDivide},${xDivide})`} style={strokeStyle} />
      </svg>
    </div>
  );
}

// Set default props
BarChartComp.defaultProps = {
  count: 0,
  color: '#db3a1b',
  radius: '18',
  width: '42',
  height: '42',
};

export default memo(BarChartComp);
